// 下書きプレビュー用：WordPressサーバーの手前にかけたApacheのベーシック認証の情報。
// 編集部がプレビュー画面で入力したものを、このタブを閉じるまでだけ保持する。
// （サイトのコードや公開ファイルには認証情報を一切含めない）
const STORAGE_KEY = 'thwm-preview-basic-auth'

let memoryValue = null

const storage = () => {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null
  } catch (e) {
    return null
  }
}

export const getPreviewAuth = () => {
  if (memoryValue) return memoryValue
  try {
    const s = storage()
    memoryValue = s ? s.getItem(STORAGE_KEY) : null
  } catch (e) {
    memoryValue = null
  }
  return memoryValue
}

export const setPreviewAuth = (id, pw) => {
  // UTF-8でエンコードしてからbase64にする（btoaはLatin-1しか扱えないため）
  const bytes = new TextEncoder().encode(`${id}:${pw}`)
  let binary = ''
  bytes.forEach((b) => {
    binary += String.fromCharCode(b)
  })
  memoryValue = `Basic ${window.btoa(binary)}`
  try {
    const s = storage()
    if (s) s.setItem(STORAGE_KEY, memoryValue)
  } catch (e) {
    // 保存できなくても、このページを開いている間はメモリ上の値で動く
  }
}

export const clearPreviewAuth = () => {
  memoryValue = null
  try {
    const s = storage()
    if (s) s.removeItem(STORAGE_KEY)
  } catch (e) {
    // noop
  }
}
